/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  AuthOptionAppearance,
  AuthOptionType,
  RouteHelper as CommonRouteHelper,
  IApplicationHeaderScreenModel,
  ScreenType,
  useScreenConfiguration,
} from "@bms/common";
import { useTranslation } from "react-i18next";

import { Button } from "../../../DesignSystem/Button";

import "./UserAuthActions.scss";

export const UserAuthActions = () => {
  const { t } = useTranslation();
  const screen = useScreenConfiguration<IApplicationHeaderScreenModel>(
    ScreenType.ApplicationHeader,
  );

  const {
    AuthOptionType: optionType = AuthOptionType.Default,
    AuthOptionAppearance: optionAppearance = AuthOptionAppearance.Default,
  } = screen;

  const shouldRenderActions = optionType !== AuthOptionType.None;

  const shouldRenderLoginAction = [
    AuthOptionType.Default,
    AuthOptionType.Signin,
    AuthOptionType.SigninSignup,
  ].includes(optionType);

  const shouldRenderRegisterAction = [AuthOptionType.SigninSignup].includes(
    optionType,
  );

  const renderAsButton = optionAppearance === AuthOptionAppearance.Button;

  const renderLoginAction = () => {
    return (
      <Button
        className="UserAuthActions__Button"
        variant={renderAsButton ? "primary" : "link"}
        onClick={() => CommonRouteHelper.goToLogin()}
      >
        {t("COMMON__SIGN_IN")}
      </Button>
    );
  };

  const renderRegisterAction = () => {
    return (
      <Button
        className="UserAuthActions__Button"
        variant={renderAsButton ? "secondary" : "link"}
        onClick={() => CommonRouteHelper.goToRegister()}
      >
        {t("COMMON__BUTTON_REGISTER")}
      </Button>
    );
  };

  if (!shouldRenderActions) {
    return null;
  }

  return (
    <div className="UserAuthActions">
      {shouldRenderLoginAction && renderLoginAction()}
      {shouldRenderRegisterAction && renderRegisterAction()}
    </div>
  );
};
